import React from 'react';

import { Snackbar, Alert } from '@mui/material';
import { useAppContext } from '@/context/context';

const SnackbarWarper = () => {
  const { snackbar, setSnackbar } = useAppContext() || {
    snackbar: { message: '', severity: 'info', open: false },
    setSnackbar: () => null
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ message: '', severity: 'info', open: false });
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
    >
      <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarWarper;
